/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkg_Log_Toast_SavedInputs */

const vi_pkg_log_toast_saved = /** @type {(inputs: Pkg_Log_Toast_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã ghi mẻ vào sổ`)
};

/**

* @param {Pkg_Log_Toast_SavedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkg_log_toast_saved = /** @type {((inputs?: Pkg_Log_Toast_SavedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkg_Log_Toast_SavedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkg_log_toast_saved(inputs)
});